module.exports = __webpack_public_path__ + "img/taxes-and-legal.b28cca2d.svg";